// extracted by mini-css-extract-plugin
module.exports = {"back":"ListLayout_back__37P-z","topHolder":"ListLayout_topHolder__3oOxo"};